import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { DecimalPipe, NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { RechtVersionListEntry } from '../../../core/gb-api/model/rechtVersionListEntry';
import { RechtMasterListEntry } from '../../../core/gb-api/model/rechtMasterListEntry';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { FormatRechteIdPipe } from '../../pipes/format/format-rechte-id.pipe';
import { NamenInhaberPfandrechtartPipe } from '../../pipes/simple/namen-inhaber-pfandrechtart.pipe';
import { TranslateNamePipe } from '../../pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-kompakt-grundpfandrecht-beschreibung',
  templateUrl: './kompakt-grundpfandrecht-beschreibung.component.html',
  preserveWhitespaces: false,
  imports: [NgTemplateOutlet, DecimalPipe, TranslatePipe, FormatRechteIdPipe, NamenInhaberPfandrechtartPipe, TranslateNamePipe]
})
export class KompaktGrundpfandrechtBeschreibungComponent extends KompaktdarstellungTemplateComponent implements OnInit {
  @Input()
  recht: RechtMasterListEntry;

  version: RechtVersionListEntry;

  @ViewChild('default', { static: true }) defaultTemplate: TemplateRef<any>;
  @ViewChild('rechteId', { static: true }) rechteIdTemplate: TemplateRef<any>;

  constructor(
    formatService: FormatConfigService,
    location: PlatformLocation,
    public translate: TranslateService,
    locationStrategy: ComponentLocationStrategy
  ) {
    super(formatService, 'GRUNDPFANDRECHT', location, locationStrategy);
    keysToTranslate<string>(['EINZELPFANDRECHT_KURZ', 'GESAMTPFANDRECHT_KURZ', 'TEILPFANDRECHT_KURZ', 'GESAMTTEILPFANDRECHT_KURZ']);
  }

  getAbkuerzungKey(input: string) {
    return input + '_KURZ';
  }

  ngOnInit() {
    super.ngOnInit();
    this.version = this.recht.version;
  }

  registerTemplates() {
    this.bindTemplates(this.defaultTemplate, 'GRUNDPFANDRECHT_TYP00');
    this.bindTemplates(this.rechteIdTemplate, 'GRUNDPFANDRECHT_TYP01');
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.defaultTemplate;
  }
}
